// @flow

import * as React from "react";

import LinkHandler from "./LinkHandler";
import { type LinkType } from "../../types";
import Icon from "./Icon";

type PropsType = {
    className: string,
    children: React.Node,
    to?: string,
    link?: LinkType,
    styles?: [],
    onClick: () => void,
};

const BackButton = (props: PropsType): React.Node => {
    const { link, styles, children, className, ...remainingProps } = props;

    const isAnchor = props.to || (link && link.url);
    const RootElement = isAnchor ? LinkHandler : "button";
    const classes = ["back-button"];

    if (className) {
        classes.push(className);
    }

    let autoProps = { ...remainingProps };
    if (link) {
        autoProps = {
            to: link.url,
            target: link.target,
        };
    }

    return (
        <RootElement {...autoProps} className={classes.join(" ")}>
            <Icon name="stem-arrow-left" />
            {link ? (
                link.title
            ) : typeof children === "string" ? (
                <span
                    className="back-button__text"
                    dangerouslySetInnerHTML={{ __html: children }}
                ></span>
            ) : (
                <span className="back-button__text">{children}</span>
            )}
        </RootElement>
    );
};

BackButton.defaultProps = {
    className: "",
    children: null,
};

export default BackButton;
